export const PHONE_COUNTRY_CODES = [
  { code: 'DE', dialCode: '+49', label: 'Allemagne (+49)' },
  { code: 'AM', dialCode: '+374', label: 'Arménie (+374)' },
  { code: 'AT', dialCode: '+43', label: 'Autriche (+43)' },
  { code: 'BE', dialCode: '+32', label: 'Belgique (+32)' },
  { code: 'BG', dialCode: '+359', label: 'Bulgarie (+359)' },
  { code: 'CY', dialCode: '+357', label: 'Chypre (+357)' },
  { code: 'HR', dialCode: '+385', label: 'Croatie (+385)' },
  { code: 'DK', dialCode: '+45', label: 'Danemark (+45)' },
  { code: 'ES', dialCode: '+34', label: 'Espagne (+34)' },
  { code: 'EE', dialCode: '+372', label: 'Estonie (+372)' },
  { code: 'FI', dialCode: '+358', label: 'Finlande (+358)' },
  { code: 'FR', dialCode: '+33', label: 'France (+33)' },
  { code: 'GR', dialCode: '+30', label: 'Grèce (+30)' },
  { code: 'GP', dialCode: '+590', label: 'Guadeloupe (+590)' },
  { code: 'GF', dialCode: '+594', label: 'Guyane française (+594)' },
  { code: 'HU', dialCode: '+36', label: 'Hongrie (+36)' },
  { code: 'IE', dialCode: '+353', label: 'Irlande (+353)' },
  { code: 'IS', dialCode: '+354', label: 'Islande (+354)' },
  { code: 'IT', dialCode: '+39', label: 'Italie (+39)' },
  { code: 'LV', dialCode: '+371', label: 'Lettonie (+371)' },
  { code: 'LI', dialCode: '+423', label: 'Liechtenstein (+423)' },
  { code: 'LT', dialCode: '+370', label: 'Lituanie (+370)' },
  { code: 'LU', dialCode: '+352', label: 'Luxembourg (+352)' },
  { code: 'MT', dialCode: '+356', label: 'Malte (+356)' },
  { code: 'MQ', dialCode: '+596', label: 'Martinique (+596)' },
  { code: 'YT', dialCode: '+262', label: 'Mayotte (+262)' },
  { code: 'MC', dialCode: '+377', label: 'Monaco (+377)' },
  { code: 'NC', dialCode: '+687', label: 'Nouvelle-Calédonie (+687)' },
  { code: 'NO', dialCode: '+47', label: 'Norvège (+47)' },
  { code: 'NL', dialCode: '+31', label: 'Pays-Bas (+31)' },
  { code: 'PL', dialCode: '+48', label: 'Pologne (+48)' },
  { code: 'PF', dialCode: '+689', label: 'Polynésie française (+689)' },
  { code: 'PT', dialCode: '+351', label: 'Portugal (+351)' },
  { code: 'RE', dialCode: '+262', label: 'Réunion (+262)' },
  { code: 'RO', dialCode: '+40', label: 'Roumanie (+40)' },
  { code: 'GB', dialCode: '+44', label: 'Royaume-Uni (+44)' },
  { code: 'SM', dialCode: '+378', label: 'Saint-Marin (+378)' },
  { code: 'SK', dialCode: '+421', label: 'Slovaquie (+421)' },
  { code: 'SI', dialCode: '+386', label: 'Slovénie (+386)' },
  { code: 'SE', dialCode: '+46', label: 'Suède (+46)' },
  { code: 'CH', dialCode: '+41', label: 'Suisse (+41)' },
  { code: 'CZ', dialCode: '+420', label: 'Tchéquie (+420)' },
  { code: 'VA', dialCode: '+379', label: 'Vatican (+379)' }
] as const;
